import { useEffect, useRef } from 'react';
import { TESTIMONIALS } from '../utils/homeData.js';
import { useTestimonials } from '../hooks/useTestimonials.js';

export default function Testimonials() {
  const trackRef = useRef(null);
  const { slide, perView, pageCount, goSlide } = useTestimonials(TESTIMONIALS.length);

  useEffect(() => {
    const track = trackRef.current;
    if (!track || !track.children[0]) return;
    const first = track.children[0];
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    const cardW = first.getBoundingClientRect().width;
    const offset = slide * perView * (cardW + gap);
    track.style.transform = `translateX(-${offset}px)`;
  }, [slide, perView]);

  return (
    <section className="v4-testimonials py-16 sm:py-20" id="testimonials" aria-labelledby="v4TestimonialsHeading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Testimonials</p>
            <h2 id="v4TestimonialsHeading" className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:text-4xl">
              What travellers say
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-nkc-muted sm:text-base">
              Real feedback from passengers passing through Nouakchott Oumtounsy.
            </p>
          </div>
          <div className="hidden gap-2 sm:flex" aria-hidden="true">
            <button type="button" className="v4-t-nav" aria-label="Previous testimonial" onClick={() => goSlide(slide - 1)}>
              ‹
            </button>
            <button type="button" className="v4-t-nav" aria-label="Next testimonial" onClick={() => goSlide(slide + 1)}>
              ›
            </button>
          </div>
        </div>

        <div className="v4-testimonials__viewport">
          <div ref={trackRef} className="v4-testimonial-track" role="list">
            {TESTIMONIALS.map((r, i) => (
              <blockquote key={r.name} className="v4-t-card" role="listitem" style={{ '--v4-t-delay': i % 3 }}>
                <div className="v4-t-card__top">
                  <span className="v4-t-card__quote" aria-hidden="true">
                    “
                  </span>
                  <div className="v4-t-card__stars" aria-label="5 out of 5 stars">
                    <span /><span /><span /><span /><span />
                  </div>
                </div>
                <p className="v4-t-card__text">{r.quote}</p>
                <footer className="v4-t-card__footer">
                  <span className="v4-t-card__avatar" aria-hidden="true">
                    {r.initials}
                  </span>
                  <span>
                    <cite className="v4-t-card__name">{r.name}</cite>
                    <span className="v4-t-card__meta">{r.meta}</span>
                  </span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>

        <div className="mt-6 flex items-center justify-between gap-4 sm:justify-center">
          <div className="flex gap-2 sm:hidden">
            <button type="button" className="v4-t-nav" aria-label="Previous testimonial" onClick={() => goSlide(slide - 1)}>
              ‹
            </button>
            <button type="button" className="v4-t-nav" aria-label="Next testimonial" onClick={() => goSlide(slide + 1)}>
              ›
            </button>
          </div>
          <div className="flex justify-center gap-2" role="tablist" aria-label="Testimonial pages">
            {Array.from({ length: pageCount }, (_, i) => (
              <button
                key={i}
                type="button"
                className={`v4-t-dot${i === slide ? ' is-active' : ''}`}
                aria-label={`Testimonials page ${i + 1}`}
                onClick={() => goSlide(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
